import React from 'react';

export interface TextBackgroundFilterProps {
    color: string;
    id: string;
}

/**
 * this filter adds a background in white and the diff will be transparent (xor)
 */
export default class TextBackgroundFilter extends React.PureComponent<TextBackgroundFilterProps> {
    render() {
        return (
            <filter x={0} y={0} width={1} height={1} id={this.props.id}>
                <feFlood floodColor={this.props.color} />
                <feComposite in="SourceGraphic" operator="xor" />
            </filter>
        );
    }
}
